/**
 * 基础接口
 * http://rap2.10niu.cn/repository/editor?id=74&mod=344&itf=3914
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const base = {
	/**
	 * 获取oss配置
	 */
	getOssConfig() {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/oss/config`,
			headers: config.headers
		});
	},
	/**
	 * 获取OSS临时授权
	 */
	getNewOssConfig(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.oss}/auth/v1/get_token`,
			params
		});
	},
	/**
	 * 保存上传OSS文件的URL
	 */
	getNewOssID(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.oss}/object/v1/save_urls`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取学校列表
	 */
	getSchoolList(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/publics/v1/get_school_list_by_account`,
			params
		});
	},
	/**
	 * 获取渠道列表
	 */
	getChannelList(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/school-video/channel-list`,
			params
		});
	},
	/**
	 * 获取代理商列表
	 */
	getAgentList(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/school-video/agent-list`,
			params
		});
	},
	/**
	 * 获取渠道下代理商的学校列表
	 */
	getChannelAgentSchoolList(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/school-video/school-list`,
			params
		});
	},
	/**
	 * 企业微信_同步年级班级
	 */
	syncJxDepartment(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/sys/sync-jx-department`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 企业微信_同步学生数据
	 */
	syncJxStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/sys/sync-jx-student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 企业微信_同步家长数据
	 */
	syncJxParent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/sys/sync-jx-parent`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 企业微信_检查学校是否开通企业微信应用
	 */
	checkOpenStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/sys/check-open-status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 企业微信_获取同步状态
	 */
	checkSyncStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/sys/check-sync-status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取OSS文件列表
	 */
	getOssList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.oss}/object/v1/list`,
			params
		});
	},
	/**
	 * 删除OSS文件
	 */
	removeUrls(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.oss}/object/v1/remove_urls`,
			data: qs.stringify(data)
		});
	}
};

export default base;
